module.exports = __webpack_public_path__ + "static/media/IMG_2385.27d3eebd.jpeg";